import { useMemo } from 'react';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { useHideCurrency } from '@pp/core/src/store/compositeSelectors/useHideCurrency';
import { EXCEPTIONS } from '../../../config/utils';
import { CurrencyFormatter } from '@pp/core/src/formatters/CurrencyFormatter';
const CURRENCY_WITH_NUMERICS: string[] = [
  'DOG6'
];
export const useCurrencySymbol = () : string => {
  const currency = useGameStateSlice.getCurrency() ?? '';
  const currentLanguage = useSettingsSlice.currentLanguage();
  const currencySymbol = useGameStateSlice.getCurrencyInfo()?.symbol;
  const hideCurrency = useHideCurrency();
  const otherthanNumbersAndPunctuation: RegExp = /[\d\u0660-\u066C\u06F0-\u06F9\p{P}   _]+/gu;
  return useMemo(() => {
    if(!currencySymbol || hideCurrency) return '';
    let finalCurrencySymbol = currencySymbol;
    if(CURRENCY_WITH_NUMERICS.includes(currencySymbol)){
      finalCurrencySymbol = currencySymbol;
    }
    else if(EXCEPTIONS[currencySymbol]){
      finalCurrencySymbol = CurrencyFormatter.format(0, currentLanguage, { currency: currency, hideCurrency }).replace(EXCEPTIONS[currency].original, EXCEPTIONS[currency].replacement).replace(otherthanNumbersAndPunctuation, '').trim();
    }
    else{
      finalCurrencySymbol = CurrencyFormatter.format(0, currentLanguage, { currency: currency, hideCurrency }).replace(otherthanNumbersAndPunctuation, '').trim();
    }
    return finalCurrencySymbol;
  },[currency, currencySymbol,currentLanguage,hideCurrency]);
};
